import { vservice } from '@niknevis/vue-modules'
import { AdminPredefinedAnswerRoute } from '@/modules/predefined-answer/routes/admin-predefined-answer.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { PredefinedAnswerRequestModel } from '@/modules/predefined-answer/models/predefined-answer-request.model'

@vservice()
export class AdminPredefinedAnswerService {
  constructor(
    private readonly routes: AdminPredefinedAnswerRoute
  ) {
  }

  update(id: number, data: PredefinedAnswerRequestModel) {
    return Inertia.put(
      this.routes.update(id),
      data
    )
  }

  store(data: PredefinedAnswerRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.routes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}